const routeConstants = {
  userPoral: [
    "/ua-uc",
    "/nm",
    "/ira",
    "/good-practices",
    "/training",
    "/tbt",
    "/audit",
    "/training-program",
    "/article",
    "/investigation",
    "/comparative-dashboard",
    "/financial-graphs",
    "/h-triangle",
    "/kpis",
    "/profile",
    "/reporting-detail",
    "/nm-detail",
    "/ira-detail",
    "/edit-reporting-detail",
    "/edit-nm-reporting-detail",
    "/edit-ira-reporting-detail",
    "/create-form",
    "/published-from",

    "/user-form-view",
    "/predictive-analysis",
    "/H-TriangleAnalysis",
    "/edit-form",
    "/setting",
    "/archive",
    "/escalation",
    "/assignform",
    "/market-place",
    "/dashboard",
    "/published-view",
    "/marketplace",
    "/safe-man-hours/rights",
    "/ohsms-portal",
    "/risk-matrix",
    // "/safety-meeting",

    "/safety-meeting/dashboard",

    "/safety-meeting/scheduled",
    "/safety-meeting/discussion/:meeting_id/scheduled",

    "/safety-meeting/inprogress",
    "/safety-meeting/discussion/:meeting_id/inprogress",

    "/safety-meeting/completed",
    "/safety-meeting/discussion/:meeting_id/completed",

    "/safety-meeting/all-closed",
    "/safety-meeting/discussion/:meeting_id/all-closed",

    "/safety-meeting/assignUsers",

    "/safety-meeting/deleted",

    // SUBMIT FORM LISTING UI ROUTES HERE
    // -- WARNING DONT CHANGE THE ORDER --
    "/submit-form-listing/unlock-form-view/:service_id/:project_id/:form_id/:unlock_request_status",
    // "/submit-form-listing/:formType/:tab/view-form/:form_id/:service_id/:project_id/:wpu_id/:timeline_id/:survey_id",
    // "/submit-form-listing/:formType/:tab/user-form-view/:form_id/:service_id/:project_id/:wpu_id/:timeline_id",
    // "/submit-form-listing/:formType/:tab/view-form/:form_id/:service_id/:project_id/:wpu_id/:timeline_id/:survey_id/:elearning_id",
    // "/submit-form-listing/:formType/:tab/view-form/:form_id/:service_id/:project_id/:wpu_id/:timeline_id/:survey_id/:elearning_id/:user_id",
    "/submit-form-listing/:formType/:tab/view-form/:form_id/:service_id/:project_id/:wpu_id/:timeline_id/:survey_id/:elearning_id/:user_id/:form_reporting_assign_id",
    "/submit-form-listing/:formType/:tab/user-form-view/:form_id/:service_id/:project_id/:wpu_id/:timeline_id/:elearning_id/:form_reporting_assign_id",
    "/submit-form-listing/:formType/:tab/analysis/:form_id/:project_id/:category_id/:user_id",
    "/submit-form-listing/:formType/:tab/published-view/:form_id",
    // "/submit-form-listing/:formType/:tab/:training_id",
    "/submit-form-listing/:formType/:tab/:training_id/:status",
    "/submit-form-listing/:formType/:tab",
    "/submit-form-listing/:formType",
    "/submit-form-listing/:formType/assign-user",

    // E-LEARNING UI ROUTES REGISTERED HERE
    "/elearning/:formType/:tab",
    "/elearning/:id/course-detail",
    // "/elearning/:formType/:tab/view-form/:form_id/:service_id/:project_id/:wpu_id/:timeline_id/:survey_id/:elearning_id/:user_id/:form_reporting_assign_id",
    // "/elearning/:formType/:tab/user-form-view/:form_id/:service_id/:project_id/:wpu_id/:timeline_id/:elearning_id/:form_reporting_assign_id",

    // POLLING UI ROUTES REGISTERED HERE
    "/polls",
    "/polls-dashboard",
    "/poll/management/:pollId",

    // GOAL UI ROUTES REGISTERED HERE
    "/goal-dashboard",
    "/goal-create",
    "/goal-inprogress",
    "/goal-completed",
    "/goal-inactivated",
    "/goal-deleted",

    "/goal-create/:goalId",
    "/goal-inprogress/:goalId",
    "/goal-completed/:goalId",
    "/goal-inactivated/:goalId",
    "/goal-deleted/:goalId",

    //Training Ui Routes registered here

    "/training/:type/dashboard",

    "/training/:type/schedule",
    "/training/:type/schedule/:id/:type/:status",

    "/training/:type/completed",
    "/training/:type/completed/:id/:type/:status",

    "/training/:type/assignUsers",

    // "/task-management",
    "/task-management/dashboard",
    "/task-management/task",
    "/task-management/task/:id/:module",
    "/task-management/task/:id/:module/:tab",
    "/safety-thought",
    "/safety-champion",
    "/report-observation",
    "/dynamic-reports",
    "/brsr",
    "/capa",
    "/work-permit",
    "/work-permit/dashboard",
    "/work-permit/calendar",
    "/work-permit/:tab",
    "/work-permit/:tab/view-form/:schedule_id/:service_id/:project_id",
    "/work-permit/:tab/user-form-view/:schedule_id/:service_id/:project_id",
    "/work-permit/:tab/published-view/:form_id",
    "/work-permit/create-template",
    "/work-permit/edit-template/:templateId",
    "/work-permit/view-template/:templateId",
    "/work-permit/assign-template/:template_id/:module",
    "/work-permit/template-settings",
    "/work-permit/import-template",
    "/mis",
    "/esg",
    "/bsc",
    "/safety-man",
    "/tool-box-talk",
    "/policy-management",
    "/inspection",
    "/checklist",
    "/survey",
    "/other",
    "/safetyadmin-map",
    "/userside-help",
    "/ticket-support",
    "/tbtactivitylist",
    "/policyactivitylist",
    "/dosdontsactivitylist",
    "/goal",
    "/msdsactivitylist",
    "/standardactivitylist",
    "/ai-alert",
    "/elearning/add-content",
    "/elearning/:courseid/add-pre-assessment",
    "/elearning/:courseid/pre-assessment",
    "/elearning/:courseid/pre-assessment/response/:assessmentId",
    "/elearning/:courseid/add-pre-assessment/:assessmentId/draft",
    "/elearning/:courseid/add-pre-assessment/:assessmentId/draft/add-question",
    "/elearning/:courseid/add-pre-assessment/:assessmentId/draft/question-preview",
    "/elearning/:courseid/:type/add-practical-assessment",
    "/elearning/:courseid/:type/add-practical-assessment/:assessmentId/draft",
    "/elearning/:courseid/:type/add-practical-assessment/:assessmentId/draft/add-question",
    "/elearning/:courseid/:type/add-practical-assessment/:assessmentId/draft/question-preview",
    "/elearning/:courseid/:type/add-final-assessment",
    "/elearning/:courseid/:type/add-final-assessment/:assessmentId/draft",
    "/elearning/:courseid/:type/add-final-assessment/:assessmentId/draft/add-question",
    "/elearning/:courseid/:type/add-final-assessment/:assessmentId/draft/question-preview",
    "/elearning/:courseid/:type/preview/:assessmentId/draft",
    "/elearning/:courseid/preview/:assessmentId/draft",
    "/elearning/:courseid/:type/preview/:assessmentId/draft/add-question",
    "/elearning/:courseid/:type/preview/:assessmentId/draft/question-preview",
    "/elearning/:courseid/assessment-result/:assessmentId",
    "/elearning/result-preview/:assessmentId",
    "/elearning/certificate/:assessmentId",
    "/elearning/12/dashboard",
    "/observations/dashboard",
    "/observations/open/details/:id",
    "/inspection",
    "/assign-template",
    "/legal",
    "/legal/dashboard",
    "/legal/register",
    "/legal/register/:id/detail",
    "/legal/register/:id/timeline",
  ],
  adminPortal: [
    "/admin-dashboard",
    "/services",
    "/companies",
    "/project",
    "/clientmaster",
    "/contractormaster",
    "/clientmaster-add",
    "/employeeMaster-add",
    "/employeemaster-detail/:id",
    "/divisiondepartment",

    "/clientmaster-detail/:id",
    "/contractor-master-detail/:id",
    "/contractormaster-add",
    "/plantmaster",
    "/plantmaster-add",
    "/ohsms-master",
    "/plantmaster-detail/:id",
    "/projectmaster",
    "/projectmaster-add",
    "/projectmaster-detail/:id",
    "/employeemaster",
    "/review-category-master",
    "/employee-setting",
    "/company-profile",
    "/company-branding",
    "/working-day",
    "/admin-master",
    "/admin-ira",
    "/admin-profile",
    "/admin-source",
    "/adminmaster-contributing-factor",
    "/adminmaster-immediate-factor",
    "/adminmaster-rootcause-analysis",
    "/adminmaster-category",
    "/admin-performance-setting",
    "/safety-thought-setting",
    "/audit-inspection-setting",
    "/admin-user",
    "/admin-space",
    "/admin-mfa",
    "/admin-sso",
    "/admin-audit-obs",
    "/admin-sso",
    "/admin-audit-obs",
    "/admin-reset-password",
    "/admin-text-analysis",
    "/admin-department",
    "/admin-contractor",
    "/admin-module",
    "/admin-aimodel",
    "/admin-hira",
    "/admin-documentmaster",
    "/admin-costingmaster",
    "/admin-lms",
    "/admin-workpermit",
    "/admin-category",
    "/document-category",
    "/topic-master",
    "/topic-master-duplicate",
    "/admin-costing",
    "/admin-help",
    "/admin-good-practice",
    "/admin-nm-workflow-setting",
    "/admin-ira-workflow-setting",
    "/admin-mis-workflow-setting",
    "/admin-uauc-workflow-setting",
    "/admin-ga-workflow-setting",
    "/admin-training-workflow-setting",
    "/admin-tbt-workflow-setting",
    "/admin-nm",
    "/admin-designation",
    "/admin-bsc-report",
    "/organisation",
  ],
  safetyAdminPortal: [
    "/safety-admin-dashboard",
    "/projects",
    "/admin-users",
    "/legal-register",
    "/legal-register/legal",
    "/legal-register/legal/create-form/:id",
    "/legal-register/legal/edit/:id",
    "/legal-register/rule",
    "/legal-register/frequency",
    "/legal-register/setting",
  ],
};

export { routeConstants };
